export const FORECAST_SUCCESS = 'Projected Forecast now enabled!';
export const ERROR = 'Sorry for the inconvenience';
export const FORECAST_SUCCESS_DESC = 'Click on the items on the left panel to see the projected forecasts';
export const REGISTER_ERROR = 'There was a problem saving your credentials. Please try again later';
export const REGISTER_SUCCESS = 'You have successfully created an account';
export const LOGIN_FAILED_DESC = "The username or the password you typed is either missing";
export const LOGIN_FAILED = 'Login Failed!';
export const REVENUES = 'revenues';
export const IMPRESSIONS = 'impressions';
export const TRAFFIC = 'traffic';
export const VISITORS = 'visitors';
export const OPTIN = 'optin';
export const CLOSE_RATE = 'closerate';
export const REVENUES_TITLE = 'dashboard.revenue.title';
export const IMPRESSIONS_TITLE = 'dashboard.impression.title';
export const TRAFFIC_TITLE = 'dashboard.traffic.title';
export const VISITORS_TITLE = 'dashboard.visitor.title';
export const OPTIN_TITLE = 'dashboard.optin.title';
export const CLOSE_RATE_TITLE = 'dashboard.closeRate.title';


// WEBPACK FOOTER //
// ./src/constants/Messages.js